import { useContext, useEffect, useState } from "react";
import "../../../index.css";
import { TeamsFxContext } from "../../Context";
import * as microsoftTeams from "@microsoft/teams-js";

export default function Announcement({unreadCount, setUnreadCount}){    ///const [isLoading, setIsLoading] = useState(true);
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    //const [accessToken, setAccessToken] = useState("");
    const [unreadIds, setUnreadIds] = useState(new Set());
    const {userPrincipalName, accessToken} = useContext(TeamsFxContext);
    const reactFunctionEndpoint = process.env.REACT_APP_FUNCTION_ENDPOINT;


    const [accesstoken, setToken]= useState(null);
    
    useEffect(()=>{
        microsoftTeams.initialize();
        microsoftTeams.getContext(async (context) => {
            microsoftTeams.authentication.getAuthToken({
                successCallback: async(token) => {  
                    setToken(token);
                },
                failureCallback: (error) => {
                    console.error("Error getting token: ", error);
                }
            });
        }
    );},[]);

    useEffect(()=>{
        if(userPrincipalName && accesstoken){
            async function fetchUnreadAnnouncements(){ 
                try{
                    const response = await fetch(`${reactFunctionEndpoint}/api/unreadCount_Announcements?userEmail=${userPrincipalName}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );
                    if (response.ok){
                        //const unreadSet = new Set(response.data.map(item => item.announcement_insertedId));
                        const unread = await response.json();
                        //console.log("Unread Announcement IDs: ", unread)

                        const unreadSet = new Set(unread);
                        setUnreadIds(unreadSet);
                        //console.log("Unread Announcement IDs: ", unreadSet);

                        setUnreadCount(unread.length);        
                        //console.log("Unread Count of Announcement IDs: ", unread.length);
                    
                    } else {
                        console.log("Failed to unread announcement count of user: ", response.status);
                    }
                } catch (error) {
                    console.error('Error fetching unread announcement count:', error);
                }
            };


            async function fetchAnnouncements(){ 
                try{
                    const response = await fetch(`${reactFunctionEndpoint}/api/UserSpecificAnnouncements?email=${userPrincipalName}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );
                    if (response.ok){
                        const data = await response.json();
                    /*  const newCount = data.filter(announcement => {
                            const viewedMap = (announcement.viewedMap || '{}');
                            return viewedMap[email] === false;
                        }).length;
                        setUnreadCount(newCount); */
                        setList(data);                    
                    } else {
                        console.log("Failed to fetch Announcments: ", response.status);
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setIsLoading(false);
                }
            };

            fetchAnnouncements();
            fetchUnreadAnnouncements();
            const interval = setInterval(fetchUnreadAnnouncements, 30000); //refresh every 30 seconds
            return() => clearInterval(interval);
        }
    },[userPrincipalName,accesstoken]);

   
    const markAsViewed = async (_id) => {
        try{
            const response = await fetch(`${reactFunctionEndpoint}/api/markAnnouncementAsViewed?announcement_insertedId=${_id}&userEmail=${userPrincipalName}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );
               /*  ,{
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({_id:_id, email: userPrincipalName,}),
            } */
            //console.log("Marked as viewed for id: ", _id);

            if (response.ok) {
                const newSet = new Set(unreadIds);
                newSet.delete(_id);
                setUnreadIds(newSet);
                setUnreadCount(newSet.size);

                //console.log("Updated unread count: ", newSet.size);
            } else {
                console.error("Failed to mark as viewed ");
            }
            /* setUnreadIds(prev => {
                const newSet = new Set(prev);
                newSet.delete(_id);
                console.log("new set after Marking viewed: ", newSet);
                setUnreadCount(newSet.size);
                return newSet;
            }); */
            //setAnnouncements((prev)=> prev.map((item) => item._id === _id?{...item, viewedMap:{...item.viewedMap,[userEmail]: true,},}:item));
        } catch(err){
            console.error("Failed to mark as viewed: ", err);
        }
    };


    return (
        <div className="flexColumn">
            <div>
                <p className="tabHeader">Local announcements </p>
                {isLoading && <p> Loading... </p>}
                {!isLoading && (
                    list.length>0 ? (
                        <table className="table announcement-table">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Valid Until</th>
                                </tr>
                            </thead>
                            <tbody>
                            {list.map((announcement)=>(
                            <tr key={announcement._id} onClick={()=>markAsViewed(announcement._id)} style={{cursor:"pointer"}} >
                                <div>
                                <td>
                                <a 
                                href={announcement.announURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                    <span style={{ fontSize: '15px'}}>{announcement.title}</span>
                                </a>
                                {(unreadIds.has(announcement._id)) && <span className="new-badge" onClick={(e)=> e.stopPropagation()}>New</span>}
                                </td>
                                </div>
                                <td className="whitespace-nowrap">{new Date(announcement.endDate).toISOString().slice(0,10)}</td>
                            </tr>
                            ))}
                            </tbody>
                        </table>
                    ):(
                        <div className="no-results">No Announcements available. </div>
                    )
                )}
            </div>
        </div>
    );
};